export const FREE_HAND_DRAWING_TOOL_NAME = 'FreeHandDrawingTool';
